<template>
  <div>
	  <section>
		  	<div class="fixed-button" @click="openPortalAluno">
				<i class="fa fa-user"></i>
				<div>
				Portal do Aluno
				</div>
			</div>
		  <div class="banner">
			  <div class="logo-container">
				  <div class="logotipo"></div>
				  INSTITUTO EDUCACIONAL CÉU AZUL - IECA</div>
			  <div class="container-banner">
				  <div class="text">Baixe nosso app!
					  <div class="buttons-stores">
						  <a target="_blank" :href="link_ios_store"><div class="phone-ios"></div></a>
					  	  <a target="_blank" :href="link_android_store"><div class="phone-android"></div></a>
					  </div>
				  </div>
				  <div class="header-iphone-container">
				  <div class="header-iphone"></div>
				  </div>
			  </div>
		  </div>
	  </section>
	  
	  <section class="section-gallery">
		  <div class="gallery">
			  <div class="photo photo-1"></div>
			  <div class="photo photo-2"></div>
			  <div class="photo photo-3"></div>
			  <div class="photo photo-4"></div>
		  </div>
	  </section>

	 <div class="title-info">Entre em contato conosco</div>
	  <section class="section-info">
	  	<div class="container-info">
			  <div class="container-ul">
				  <ul>
					 <li><i class="fa fa-phone" aria-hidden="true"></i><a href="tel://313496-1180"> (31) 3496-1180</a></li>
					 <li><i class="fa fa-map-marker" aria-hidden="true"></i> Rua João Gualberto dos Santos, 108 - 
						Céu Azul Belo Horizonte-MG - CEP.: 31.580-000</li>
					 <li><i class="fa fa-envelope" aria-hidden="true"></i><a href="mailto:fatieca@yahoo.com.br">fatieca@yahoo.com.br</a></li>
					 <li><i class="fa fa-clock-o" aria-hidden="true"></i> De seg a sex 07:00–11:30, 13:10–17:20</li>
					 <li>
						 <!-- <a :href="link_facebook" target="_blank" class="margin-5"><i class=" fa fa-whatsapp" aria-hidden="true"></i></a> -->
						 <a :href="link_facebook" target="_blank" class="margin-5"><i class=" fa fa-facebook" aria-hidden="true"></i></a>
						 <a :href="link_instagram" target="_blank" class="margin-5"><i class=" fa fa-instagram" aria-hidden="true"></i></a>
					 </li>
				  </ul>
			  </div>
	  	</div>
	  	<div class="container-map">
			  <div class="square-back-map"></div>
			  <div class="map">
				  <!-- map -->
				  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15013.37183501018!2d-43.9974312!3d-19.8254365!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x1b7c88f2040da9b2!2sInstituto%20Educacional%20C%C3%A9u%20Azul!5e0!3m2!1spt-BR!2sbr!4v1583848507185!5m2!1spt-BR!2sbr"  frameborder="0" style="border:0;width: 100%;height: 100%;" allowfullscreen=""></iframe>
				  <!-- map -->
			  </div>
	  	</div>
	  </section>
	
	  <section class="section-footer">
	  	<div class="footer">
			  <a href="https://jrsistemas.net" target="_blank" class="link-footer"> Copyright © 2003-{{new Date().getFullYear()}} JR SISTEMAS E TECNOLOGIA LTDA
			05.964.446/0001-50. Todos direitos reservados.</a>
	  	</div>
	  </section>
 
  </div>
</template>

<script>
import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios'

export default {
	name: 'Home',
  components: {
	  HelloWorld
  },
  data(){
	  return{
		  link_ios_store: "",
		  link_android_store: "",
		  link_facebook: "",
		  link_whatsapp: "",
		  link_instagram: "",
		  link_portal_do_aluno: ""
	  }
  },
 created(){
	 axios.get('config/config.json').then(res=>{
		 let { link_ios_store,
		  	   link_android_store,
		  	   link_facebook,
		  	   link_whatsapp,
		  	   link_instagram,
			   link_portal_do_aluno} = res.data;

		  this.link_ios_store = link_ios_store;		
		  this.link_android_store = link_android_store;
		  this.link_facebook = link_facebook;
		  this.link_whatsapp = link_whatsapp;
		  this.link_instagram = link_instagram;
		  this.link_portal_do_aluno = link_portal_do_aluno;
	 })
 },
 methods:{
	openPortalAluno(){
		window.open(this.link_portal_do_aluno, "_blank")
	}
 }
}
</script>
